import { render } from "./ExpandedViewItem.vue?vue&type=template&id=4698995c"
import script from "./ExpandedViewItem.vue?vue&type=script&lang=js"
export * from "./ExpandedViewItem.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__